// import React, { useState, useEffect } from "react";
// import styles from './bar.module.css'

// const Bar = ({ data }) => {
//     console.log(data, "here in graph")
//     const [maxRides, setMaxRides] = useState(1);
//     const [tooltip, setTooltip] = useState({ visible: false, x: 0, y: 0, value: 0, type: '' });

//     useEffect(() => {
//         const max = data.length > 0 ? Math.max(...data.map((item) => item.rides)) : 1;
//         const roundedMax = max % 10 === 0 ? max : Math.ceil(max / 10) * 10;
//         setMaxRides(roundedMax || 1);
//     }, [data]);


//     const filledAreaPoints = [
//         ...data.map((point, index) => {
//             const x = (index / (data.length - 1)) * 100;
//             const y = 100 - (point.rides / maxRides) * 100;
//             return `${x},${y}`;
//         }),

//         ...data.slice().reverse().map((point, index) => {
//             const x = ((data.length - 1 - index) / (data.length - 1)) * 100;
//             const y = 100 - (point.completed / maxRides) * 100;
//             return `${x},${y}`;
//         }),

//     ].join(" ");

//     console.log('heelo trying to revers', ...data.map((point, index) => {
//         const x = (index / (data.length - 1)) * 100;
//         const y = 100 - (point.rides / maxRides) * 100;
//         return `${x},${y}\n`;
//     }), 'to this ', ...data.slice().reverse().map((point, index) => {
//         const x = ((data.length - 1 - index) / (data.length - 1)) * 100;
//         const y = 100 - (point.completed / maxRides) * 100;
//         return `${x},${y}\n`;
//     }))


//     return (
//         <div className={styles.contain}>
//             <div className={styles.yAxisStyle}>
//                 {Array.from({ length: 6 }, (_, i) => {
//                     const value = maxRides - (i * maxRides) / 5;
//                     return (
//                         <div key={i} className={styles.yAxisLabelStyle} style={{ top: `${(i * 100) / 5}%` }}>
//                             {Math.round(value)}
//                         </div>
//                     );
//                 })}
//             </div>

//             <div className={styles.chartContainerStyle}>
//                 <div className={styles.xAxisStyle}>
//                     {data.map((point, index) => (
//                         <div key={index} className={styles.xAxisLabelStyle} style={{
//                             left: `${(index / (data.length - 1)) * 100}%`,
//                             transform: "translateX(-50%)"
//                         }}>
//                             {point.label}
//                         </div>
//                     ))}
//                 </div>
//                 <svg className={styles.filledArea} viewBox="0 0 100 100" preserveAspectRatio="none">
//                     {/* <polygon points={areatoFill(data, maxRides, 'rides', 'completed')} fill="rgba(7, 7, 237, 0.45)" style={{ pointerEvents: "none" }} />
//                     <polygon points={areatoFill(data, maxRides, 'completed', 'cancelled')} fill="rgba(19, 142, 19, 0.4)" style={{ pointerEvents: "none" }} />
//                     <polygon points={areatoFill(data, maxRides, 'cancelled')} fill="rgba(222, 25, 15, 0.42)" style={{ pointerEvents: "none" }} /> */}
//                 </svg>
//                 <div className={styles.gridLinesContainerStyle}>
//                     {Array.from({ length: 6 }).map((_, i) => (
//                         <div key={i} style={{ top: `${(i * 100) / 5}%` }} className={styles.gridLineStyle} />
//                     ))}
//                 </div>
//                 <svg className={styles.svgStyle}>
//                     {svgRender(data, maxRides, setTooltip, tooltip, 'rides')}
//                     {svgRender(data, maxRides, setTooltip, tooltip, 'completed')}
//                     {svgRender(data, maxRides, setTooltip, tooltip, 'cancelled')}
//                 </svg>

//             </div>
//         </div >

//     );
// };
// const areatoFill = (data, maxRides, first, sec) => {
//     return [
//         ...data.map((point, index) => {
//             const x = (index / (data.length - 1)) * 100;
//             const y = 100 - (point[first] / maxRides) * 100;
//             return `${x},${y}`;
//         }),
//         100, 100,
//         ...data.slice().reverse().map((point, index) => {
//             const x = ((data.length - 1 - index) / (data.length - 1)) * 100;
//             const y = 100 - (point[sec] / maxRides) * 100;
//             return `${x},${y}`;
//         }), 0, 100

//     ].join(" ");
// }

// const svgRender = (data, maxRides, setTooltip, tooltip, title) => {
//     return (
//         <>
//             {
//                 data.map((_, index) => {
//                     if (index === data.length - 1) return null;
//                     const x1 = (index / (data.length - 1)) * 100;
//                     const y1 = 100 - (data[index][title] / maxRides) * 100;
//                     const x2 = ((index + 1) / (data.length - 1)) * 100;
//                     const y2 = 100 - (data[index + 1][title] / maxRides) * 100;
//                     return (
//                         <line
//                             key={index}
//                             x1={`${x1}%`}
//                             y1={`${y1}%`}
//                             x2={`${x2}%`}
//                             y2={`${y2}%`}
//                             stroke={title === 'rides' ? 'blue' : title === 'completed' ? 'green' : 'red'}
//                             strokeWidth="1"
//                         />
//                     );
//                 })
//             }
//             {
//                 data.map((point, index) => {
//                     const x = (index / (data.length - 1)) * 100;
//                     const y = 100 - (point[title] / maxRides) * 100;
//                     return (
//                         <g key={index} style={{ cursor: "pointer" }}>
//                             <circle
//                                 cx={`${x}%`}
//                                 cy={`${y}%`}
//                                 r="4.5"
//                                 fill={title === 'rides' ? 'blue' : title === 'completed' ? 'green' : 'red'}
//                                 onPointerEnter={() => setTooltip({ visible: true, x, y, value: point[title], type: title })}
//                                 onPointerLeave={() => setTooltip({ visible: false, x: 0, y: 0, value: 0 })}
//                             />
//                             {/* <text
//                                 x={`${x}%`}
//                                 y={`${y}%`}
//                                 fontSize="10px"
//                                 fill="#fff"
//                                 textAnchor="middle"
//                                 dominantBaseline="middle"
//                                 style={{ pointerEvents: "none" }}
//                             >
//                                 {point[title]}
//                             </text> */}
//                             {tooltip.visible && tooltip.x === x && tooltip.y === y && tooltip.type === title && (
//                                 <g>
//                                     <rect
//                                         x={`${x - 4}%`}
//                                         y={`${y - 9}%`}
//                                         width="8%"
//                                         height="7%"
//                                         fill="var(--primary-color)"
//                                         rx="4"
//                                         ry="4"
//                                     />
//                                     <text
//                                         x={`${x}%`}
//                                         y={`${y - 5}%`}
//                                         fontSize="14px"
//                                         fill="var(--primary-bgcolor)"
//                                         textAnchor="middle"
//                                         dominantBaseline="middle"
//                                         style={{ pointerEvents: "none" }}
//                                     >
//                                         {tooltip.value} rides
//                                     </text>
//                                 </g>
//                             )}
//                         </g>)
//                 })
//             }
//         </>

//     )

// }


// export default Bar;



import React, { useState, useEffect, useMemo } from "react";
import styles from './bar.module.css'

const SERIES = [
    { key: 'rides', label: 'Rides', color: '#2a78d6', fill: 'rgba(42,120,214,0.12)' },
    { key: 'completed', label: 'Completed', color: '#1baf7a', fill: 'rgba(27,175,122,0.12)' },
    { key: 'cancelled', label: 'Cancelled', color: '#e34948', fill: 'rgba(227,73,72,0.12)' },
    { key: 'requests', label: 'Requests', color: '#c6c839', fill: 'rgba(44,44,143,0.10)' },
    { key: 'pending', label: 'Pending', color: '#5c5858', fill: 'rgba(92,88,88,0.10)' },
];

// Catmull-Rom -> cubic Bezier smoothing. Turns raw point-to-point segments
// into a continuous curve so single-day spikes read as peaks, not tents.
const smoothPath = (pts) => {
    if (!pts || pts.length === 0) return '';
    if (pts.length === 1) return `M ${pts[0].x},${pts[0].y}`;
    if (pts.length === 2) {
        return `M ${pts[0].x},${pts[0].y} L ${pts[1].x},${pts[1].y}`;
    }

    let d = `M ${pts[0].x},${pts[0].y} `;
    for (let i = 0; i < pts.length - 1; i++) {
        const p0 = pts[i - 1] || pts[i];
        const p1 = pts[i];
        const p2 = pts[i + 1];
        const p3 = pts[i + 2] || p2;

        const cp1x = p1.x + (p2.x - p0.x) / 6;
        const cp1y = p1.y + (p2.y - p0.y) / 6;
        const cp2x = p2.x - (p3.x - p1.x) / 6;
        const cp2y = p2.y - (p3.y - p1.y) / 6;

        d += `C ${cp1x},${cp1y} ${cp2x},${cp2y} ${p2.x},${p2.y} `;
    }
    return d;
};

const Bar = ({ data = [] }) => {
    const [maxRides, setMaxRides] = useState(1);
    const [tooltip, setTooltip] = useState({ visible: false, index: -1, seriesKey: '' });

    useEffect(() => {
        const max = data.length > 0
            ? Math.max(...data.flatMap((item) => [item.rides, item.completed, item.cancelled, item.requests, item.pending]))
            : 1;
        const roundedMax = max === 0 ? 1 : (max % 10 === 0 ? max : Math.ceil(max / 10) * 10);
        setMaxRides(roundedMax);
    }, [data]);

    // Precompute pixel-free (0-100) coordinates for each series, guarding against
    // the single-point case where (data.length - 1) would be 0.
    const points = useMemo(() => {
        const denom = Math.max(data.length - 1, 1);
        return SERIES.reduce((acc, series) => {
            acc[series.key] = data.map((point, index) => ({
                x: data.length === 1 ? 50 : (index / denom) * 100,
                y: 100 - (point[series.key] / maxRides) * 100,
                value: point[series.key],
            }));
            return acc;
        }, {});
    }, [data, maxRides]);

    const areaPath = (seriesKey) => {
        const pts = points[seriesKey];
        if (!pts || pts.length === 0) return '';
        const curve = smoothPath(pts);
        const last = pts[pts.length - 1];
        const first = pts[0];
        return `${curve} L ${last.x},100 L ${first.x},100 Z`;
    };

    if (data.length === 0) {
        return (
            <div className={styles.contain}>
                <p className={styles.emptyState}>No ride data for this period.</p>
            </div>
        );
    }

    return (
        <div className={styles.contain}>
            <div className={styles.legend}>
                {SERIES.map((series) => (
                    <span key={series.key} className={styles.legendItem}>
                        <span className={styles.legendSwatch} style={{ background: series.color }} />
                        {series.label}
                    </span>
                ))}
            </div>

            <div className={styles.chartRow}>
                <div className={styles.yAxisStyle}>
                    <div className={styles.yAxisInner}>
                        {Array.from({ length: 6 }, (_, i) => {
                            const value = maxRides - (i * maxRides) / 5;
                            return (
                                <div key={i} className={styles.yAxisLabelStyle} style={{ top: `${(i * 100) / 5}%` }}>
                                    {Math.round(value)}
                                </div>
                            );
                        })}
                    </div>
                </div>

                <div className={styles.chartContainerStyle}>
                    <div className={styles.xAxisStyle}>
                        {data.map((point, index) => (
                            <div
                                key={index}
                                className={styles.xAxisLabelStyle}
                                style={{
                                    left: `${data.length === 1 ? 50 : (index / (data.length - 1)) * 100}%`,
                                    transform: "translateX(-50%)"
                                }}
                            >
                                {point.label}
                            </div>
                        ))}
                    </div>

                    <div className={styles.gridLinesContainerStyle}>
                        {Array.from({ length: 6 }).map((_, i) => (
                            <div key={i} style={{ top: `${(i * 100) / 5}%` }} className={styles.gridLineStyle} />
                        ))}
                    </div>

                    <svg className={styles.filledArea} viewBox="0 0 100 100" preserveAspectRatio="none">
                        {SERIES.map((series) => (
                            <path
                                key={series.key}
                                d={areaPath(series.key)}
                                fill={series.fill}
                                stroke="none"
                                style={{ pointerEvents: "none" }}
                            />
                        ))}
                    </svg>

                    <svg className={styles.svgStyle} viewBox="0 0 100 100" preserveAspectRatio="none">
                        {SERIES.map((series) => (
                            <path
                                key={series.key}
                                d={smoothPath(points[series.key])}
                                fill="none"
                                stroke={series.color}
                                strokeWidth="2"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                vectorEffect="non-scaling-stroke"
                            />
                        ))}
                    </svg>

                    <div className={styles.markerLayer}>
                        {SERIES.map((series) => (
                            <SeriesMarkers
                                key={series.key}
                                seriesKey={series.key}
                                color={series.color}
                                label={series.label}
                                points={points[series.key]}
                                tooltip={tooltip}
                                setTooltip={setTooltip}
                            />
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
};

const SeriesMarkers = ({ seriesKey, color, label, points, tooltip, setTooltip }) => {
    if (!points || points.length === 0) return null;

    return (
        <>
            {points.map((p, index) => {
                const isActive = tooltip.visible && tooltip.index === index && tooltip.seriesKey === seriesKey;
                return (
                    <div
                        key={index}
                        className={styles.marker}
                        style={{
                            left: `${p.x}%`,
                            top: `${p.y}%`,
                            background: color,
                        }}
                        onPointerEnter={() => setTooltip({ visible: true, index, seriesKey })}
                        onPointerLeave={() => setTooltip({ visible: false, index: -1, seriesKey: '' })}
                    >
                        {isActive && (
                            <div className={styles.tooltip} style={{ background: color }}>
                                {p.value} {label.toLowerCase()}
                            </div>
                        )}
                    </div>
                );
            })}
        </>
    );
};

export default Bar;
